"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getBackgroundColor = getBackgroundColor;
exports.getIntentStyles = getIntentStyles;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intents = _interopRequireDefault(require("@ux/intents"));
/* VENDOR */

const intents = function () {
  return new _intents.default();
}();
var _default = exports.default = intents;
/**
 * Converts the intent object to a css object which can be used in linaria.
 * Example:
 * const Container = styled.div`
 *   ${getIntentStyles(intents.ux.box)}
 * `;
 * @param {object} intent The intent to extract styling rule from.
 * @returns {object} A css object containing intent styling.
 */
function getIntentStyles(intent) {
  const cssProps = {
    foregroundColor: 'color',
    density: 'skip'
  };
  const newIntent = {};
  if (!intent) {
    return '';
  }
  Object.keys(intent).map(key => {
    if (cssProps[key]) {
      if (cssProps[key] !== 'skip') {
        newIntent[cssProps[key]] = intent[key];
      }
    } else {
      newIntent[key] = intent[key];
    }
  });
  return newIntent;
}

/**
 * Accepts an object containing background color information and returns the correlating intent or RGB property.
 * @param {object} backgroundObject The object containing background color information.
 * @returns {string} A string containing the intent or RGB to use in component styling.
 */
function getBackgroundColor(backgroundObject) {
  if (typeof backgroundObject !== 'object' || backgroundObject === null) return null;
  if ('intent' in backgroundObject) {
    const intent = backgroundObject.intent;
    const levels = intent.split('.');
    // access intent object for each level
    let val = intents;
    levels?.map(level => {
      val = val[level];
    });
    return val;
  }
  return backgroundObject?.rgb;
}
getBackgroundColor.propTypes = {
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })])
};